// 클립보드 복사 버튼 — 30초 후 클립보드를 자동으로 비운다.
// Plan §보안 요구: "클립보드 복사 → 30초 후 자동 삭제".
//
// 다른 CopyButton을 연속 클릭하면 이전 타이머를 취소해 30초를 재시작한다.

import { useState } from 'react';
import { useToast } from './Toast';

const CLIPBOARD_EXPIRE_MS = 30_000;

// 전역 단일 타이머 — 컴포넌트가 언마운트되어도 타이머는 살아있어야 한다.
let globalTimer: ReturnType<typeof setTimeout> | null = null;

function scheduleClear() {
  if (globalTimer) clearTimeout(globalTimer);
  globalTimer = setTimeout(() => {
    // writeText('') 은 일부 브라우저가 거부하므로 공백 문자를 채워 기존 값을 덮어쓴다.
    navigator.clipboard?.writeText(' ').catch(() => {});
    globalTimer = null;
  }, CLIPBOARD_EXPIRE_MS);
}

interface Props {
  value: string;
  label?: string;
  className?: string;
}

export function CopyButton({ value, label = '복사', className }: Props) {
  const [copied, setCopied] = useState(false);
  const toast = useToast();

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      scheduleClear();
      setCopied(true);
      toast.success('복사됨 — 30초 후 자동 삭제');
      window.setTimeout(() => setCopied(false), 2_000);
    } catch {
      toast.error('클립보드 접근 실패');
    }
  };

  return (
    <button type="button" className={`copy-btn ${className ?? ''}`} onClick={onClick}>
      {copied ? '✓' : label}
    </button>
  );
}
